module.exports = __webpack_public_path__ + "img/shuixian2.3ff64b9c.png";